import axiosInstance from './axiosInstance'

export interface FalabellaInvoiceUploadRequest {
  orderItemIds: string[]
  invoiceNumber: string
  invoiceDate: string
  invoiceType: string
  operatorCode: string
  invoiceDocumentFormat: string
  invoiceDocument: string
}

export interface FalabellaInvoiceValidateRequest {
  orderItemIds: string[]
  invoiceNumber: string
  invoiceDate: string
  invoiceType: string
  operatorCode: string
}

export interface FalabellaInvoiceInfo {
  supportedTypes: string[]
  supportedOperators: string[]
  supportedFormats: string[]
}

export interface FalabellaInvoiceResponse {
  success: boolean
  message: string
  data?: any
  error?: string
}

class FalabellaInvoiceService {
  // Subir factura PDF
  async uploadInvoice(data: FalabellaInvoiceUploadRequest): Promise<FalabellaInvoiceResponse> {
    try {
      const response = await axiosInstance.post('/falabella/invoice/upload', data)
      return response.data
    } catch (error: any) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al subir la factura',
        error: error.message
      }
    }
  }

  // Validar datos de factura
  async validateInvoice(data: FalabellaInvoiceValidateRequest): Promise<FalabellaInvoiceResponse> {
    try {
      const response = await axiosInstance.post('/falabella/invoice/validate', data)
      return response.data
    } catch (error: any) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al validar la factura',
        error: error.message
      }
    }
  }

  // Obtener información de tipos soportados
  async getInvoiceInfo(): Promise<FalabellaInvoiceResponse> {
    try {
      const response = await axiosInstance.get('/falabella/invoice/info')
      return response.data
    } catch (error: any) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener información de facturas',
        error: error.message
      }
    }
  }
}

export const falabellaInvoiceService = new FalabellaInvoiceService()
